import type { UserRole } from '@/types/auth'
import { ALL_ROLES } from '@/lib/auth/roleSets'

const STORAGE_KEY = 'clinic-ms-active-role'

function isUserRole(value: unknown): value is UserRole {
  return typeof value === 'string' && (ALL_ROLES as readonly string[]).includes(value)
}

export function readActiveRoleFromStorage(): UserRole | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return isUserRole(raw) ? raw : null
  } catch {
    return null
  }
}

export function writeActiveRoleToStorage(role: UserRole | null): void {
  if (typeof window === 'undefined') return
  try {
    if (role === null) {
      window.localStorage.removeItem(STORAGE_KEY)
    } else {
      window.localStorage.setItem(STORAGE_KEY, role)
    }
  } catch {
    // ignore quota / private mode
  }
}
